import { Component, OnInit } from '@angular/core';
import { StepService } from 'src/app/services/step.service';
import { Dispatch } from 'src/app/models/dispatch';
import { StoreService } from 'src/app/services/store.service';
import { ResponsiveLayoutService } from 'src/app/services/responsive-layout.service';
import { Observable, of } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { catchError, delay, finalize, tap } from 'rxjs/operators';
import { CementoPaymentService } from 'src/app/services/cemento-payment.service';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es-CL';
registerLocaleData(localeEs, 'es');

@Component({
  selector: 'app-pedido',
  templateUrl: './pedido.component.html',
  styleUrls: ['./pedido.component.css']
})
export class PedidoComponent implements OnInit {
  dispatch!: Observable<Dispatch | null>;
  hasLoadError = false;
  isDetalleCemento = false;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly spinner: NgxSpinnerService,
    private readonly storeService: StoreService,
    private readonly cementoPaymentService: CementoPaymentService,
    public responsiveService: ResponsiveLayoutService,
    private readonly stepService: StepService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.hasLoadError = false;
      this.spinner.show();
      const isCementoRoute = this.route.snapshot.routeConfig?.path === 'cemento/pedido/:id';
      this.isDetalleCemento = isCementoRoute;
      if (isCementoRoute) {
        const queryParamEntries = this.route.snapshot.queryParamMap.keys.map(key => ({
          key,
          values: this.route.snapshot.queryParamMap.getAll(key),
        }));
        console.log('[Mercado Pago] Retorno recibido en el pedido de cemento', {
          url: window.location.href,
          routeParams: params,
          queryParams: this.route.snapshot.queryParams,
          queryParamEntries,
        });
      }
      const request = isCementoRoute
        ? this.cementoPaymentService.getDispatchResult(params['id'])
        : this.storeService.get_dispatch(params['id']);
      this.dispatch = request.pipe(
        delay(100),
        tap(result => {
          if (isCementoRoute) {
            console.log('[Mercado Pago] Resultado recibido desde la API', result);
          }
        }),
        catchError(() => {
          this.hasLoadError = true;
          return of(null);
        }),
        finalize(() => this.spinner.hide())
      );
    });
    this.stepService.changeStep(6);
  }

  getQuantityUnitLabel(quantity: number, unitLabel?: string): string {
    const normalizedLabel = String(unitLabel ?? '').trim();
    if (!normalizedLabel) {
      return 'm³';
    }
    if (normalizedLabel.toLowerCase() === 'pallet') {
      return quantity === 1 ? 'Pallet' : 'Pallets';
    }
    return normalizedLabel;
  }

}
